/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_DescriptionInputs */

const en_common_support_description = /** @type {(inputs: Common_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a ticket and our team will get back to you`)
};

const zh_common_support_description = /** @type {(inputs: Common_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工单反馈问题,我们会尽快回复你`)
};

/**
* | output |
* | --- |
* | "Submit a ticket and our team will get back to you" |
*
* @param {Common_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_description = /** @type {((inputs?: Common_Support_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_description(inputs)
	return zh_common_support_description(inputs)
});
export { common_support_description as "common.support.description" }